import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { logEvent } from 'firebase/analytics';
import { db, analytics } from './firebase';

/**
 * Track a button click in both Firestore and Analytics
 * @param {string} buttonId - Identifier for the button
 * @param {string} buttonText - Text displayed on the button
 * @param {string} sectionName - Section where the button is located
 * @param {Object} additionalData - Any additional data to track
 */
export const trackButtonClick = async (buttonId, buttonText, sectionName, additionalData = {}) => {
  try {
    // Log to Firestore
    await addDoc(collection(db, 'button_clicks'), {
      buttonId,
      buttonText,
      sectionName,
      timestamp: serverTimestamp(),
      ...additionalData
    });

    // Log to Analytics
    logEvent(analytics, 'button_click', {
      button_id: buttonId,
      button_text: buttonText,
      section_name: sectionName,
      ...additionalData
    });

    
  } catch (error) {
    console.error('Error tracking button click:', error);
  }
};

/**
 * Track a form submission
 * @param {string} formId - Identifier for the form
 * @param {string} formType - Type of form (e.g., 'contact', 'waitlist')
 * @param {Object} formData - Form data (sensitive data should be excluded)
 */
export const trackFormSubmission = async (formId, formType, formData = {}) => {
  try {
    // Don't store emails or personal info in analytics
    const safeFormData = { ...formData };
    if (safeFormData.email) safeFormData.email = 'email_provided';
    if (safeFormData.name) safeFormData.name = 'name_provided';
    if (safeFormData.phone) safeFormData.phone = 'phone_provided';

    // Log to Firestore
    await addDoc(collection(db, 'form_submissions'), {
      formId,
      formType,
      timestamp: serverTimestamp(),
      ...formData // Store complete data in Firestore
    });

    // Log to Analytics with safe data
    logEvent(analytics, 'form_submission', {
      form_id: formId,
      form_type: formType,
      ...safeFormData
    });

    
  } catch (error) {
    console.error('Error tracking form submission:', error);
  }
};

/**
 * Track a page view
 * @param {string} pageName - Name of the page
 * @param {string} pageUrl - URL of the page
 */
export const trackPageView = (pageName, pageUrl) => {
  try {
    logEvent(analytics, 'page_view', {
      page_name: pageName,
      page_url: pageUrl
    });
    
    
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};
